import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItemDto } from './menu-item-dto';



@Injectable({ providedIn: 'root' })
export class SideNavService {

 public sideNavToggleSubject: Subject<any> = new Subject();
 private menu: Map<string, MenuItemDto[]> = new Map<string, MenuItemDto[]>;
 private loading: boolean = false;

  constructor() { }


  public toggle() {
    return this.sideNavToggleSubject.next(null);
  }
  
  public setMenuItems(menu: Map<string, MenuItemDto[]>)
  {
    this.menu = menu;
  }

  public getMenuItems()
  {
    return this.menu;
  }

  public setLoading(loading: boolean)
  {
    this.loading = loading;
  }

  public isLoading()
  {
    return this.loading;
  }

  getRoleMenuItem(link: string)
  {
    let role = '';
    if (link)
    {
      this.menu.forEach((value: MenuItemDto[], key: string) =>
      {
        value.forEach((item) => {
          
          if (item && link.includes(item.menuRouterLink))
          {
            role = item.profiles;
          }
          });
        })
      }
      return role;
  }
}
